export default function footer({ currentLanguage, handleLanguageChange }) {
  return (
    <>
      {" "}
      <footer>
        <p>
          Created By :{" "}
          <a href="https://www.linkedin.com/in/ahmad-w-al-far-9799b52b3/">
            Ahmad Far
          </a>
        </p>
        <button style={currentLanguage==="ar"?{left:"10px"}:{right:"10px"}} className="language-btn" onClick={handleLanguageChange}>{currentLanguage==="ar"?"English":"العربية"}</button>
      </footer>
    </>
  );
}
